import { Link } from "wouter";
import { Button } from "@/components/ui/button";
import { formatRewardAmount } from "@/lib/textUtils";
import { RecruitmentStatus } from "@/lib/schema";
import { RecruitmentStatusIndicator } from "./RecruitmentStatusIndicator";

interface JobListItemProps {
  job: {
    id: string;
    title: string;
    rewardInAirPoints?: number;
    recruitmentStatus?: RecruitmentStatus;
  };
  index: number;
}

export function JobListItem({ job, index }: JobListItemProps) {
  return (
    <div 
      key={job.id || index} 
      className="w-full bg-white p-4 hover:shadow-sm transition-all duration-200" 
      style={{
        borderWidth: '0px 0px 0.5px 0px',
        borderStyle: 'solid',
        borderColor: '#EAEAEA'
      }}
      data-testid={`job-item-${index}`}
    >
      <div className="flex justify-between items-center gap-4">
        {/* Left: Status Indicator + Title */}
        <div className="flex items-center gap-4 flex-1 min-w-0">
          <RecruitmentStatusIndicator 
            status={job.recruitmentStatus} 
            size="sm" 
          />
          <h4 className="font-medium text-gray-900 text-sm truncate">
            {job.title}
          </h4>
        </div>
        
        {/* Right: Reward + Button */}
        <div className="flex items-center gap-4 flex-shrink-0">
          <span className="font-semibold text-gray-900 space-grotesk text-sm">
            R{formatRewardAmount(job.rewardInAirPoints)}
          </span>
          <div 
            style={{
              width: '19px',
              height: '0px',
              transform: 'rotate(-90deg)',
              opacity: 1,
              borderWidth: '1px',
              border: '1px solid #EAEAEA'
            }}
          />
          <Link href={`/jobs/${job.id}`}>
            <Button 
              variant="secondary"
              size="sm" 
              data-testid={`button-refer-${index}`}
            >
              VIEW
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
}
